import Control from "../../../../../common/Controls/Control";
import RCPROPrestationsInternationales from "./RCPROPrestationsInternationales";
import useRCPROQuestion from "./useRCPROQuestion";

const RCPROMarketing = ({ company }) => {
  const { updateRcproData, onBlur, errors, inputsConfig, formState } =
    useRCPROQuestion({ company });
  const activityKey = "marketing";

  return (
    <div>
      <Control
        label={inputsConfig.marketingContenuPublic.label}
        type="btnList"
        name="marketingContenuPublic"
        value={company.RCPRO.marketingContenuPublic}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.marketingContenuPublic.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
      <Control
        label={inputsConfig.marketingDroitUtilisationVerifie.label}
        type="btnList"
        name="marketingDroitUtilisationVerifie"
        value={company.RCPRO.marketingDroitUtilisationVerifie}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.marketingDroitUtilisationVerifie.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
      <RCPROPrestationsInternationales
        company={company}
        activityKey={activityKey}
      />
    </div>
  );
};

export default RCPROMarketing;
